import { render } from "./SmsLogs.vue?vue&type=template&id=cca6d4de"
import script from "./SmsLogs.vue?vue&type=script&lang=js"
export * from "./SmsLogs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__